import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import Icon from '../common/Icon'

// This container is always rendered, but renders e.g. a chart,
// an error, or nothing depending on the state of the selection
const MarkersWithinList = ({ uiStore, selectionStore, marker, selected }) => (
  <li
    ref='item' className={classnames({
      'marker-item': true,
      selected
    })}
  >
    <nav>
      <span
        className='name' onClick={() => {
          uiStore.setBoundsToItem(marker)
          selectionStore.item.analysis.selectedMarkerId = marker.id
        }}
      >
        <Icon id='fa-map-marker' />
        <span>{marker.name}</span>
      </span>
    </nav>
  </li>
)

export default inject('selectionStore', 'uiStore')(
  observer(MarkersWithinList)
)
